import React from 'react';
import './About.css';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import ImageLoader from '../../common/ImageLoader/ImageLoader';
import ScrollIndicator from '../../common/ScrollIndicator/ScrollIndicator';
import Reveal from 'react-reveal/Reveal';


const About = ({ content, image }) => (
  <div className="about-wrapper">
    <div className="square"></div>
    <section className="about container" id="rolam">
      <Reveal effect="grow-in-bottom">
        <div className="row justify-content-center">
          <div className="col-10 col-xs-8 col-md-6 col-lg-4 mx-auto mx-md-0 mb-5 mb-md-0 d-flex align-items-center mt-4 mt-lg-3 order-2 order-lg-0">
            <div className="about-image-wrapper">
              <ImageLoader src={image} alt="Berki Melinda" className="about-image" />
            </div>
          </div>
          <div className="col-1 d-none d-lg-block"></div>
          <div className="col-12 col-md-7 col-lg-4">
            <h1>Rólam</h1>
            <span className="section__description">
              {ReactHtmlParser(content)}
            </span>
            <Link to="/rolam" className="my-btn mt-4">Bővebben</Link>
          </div>
        </div>
      </Reveal>

      <ScrollIndicator to="/#modszertan" />

    </section>
  </div>
);


About.propTypes = {
  content: PropTypes.string,
  image: PropTypes.string
};


export default About;



// WEBPACK FOOTER //
// ./src/components/Home/About/About.js